/**
 * Money model representing a monetary value.
 * Backend: Domain\Shared\DTOs\MoneyDTO
 */
interface MoneyModel {
  amount: number
  currency: string
  scale: number
  formatted?: string
}

const DEFAULT_NEW_MONEY = (): MoneyModel => ({
  amount: 0,
  currency: 'EUR',
  scale: 2,
  formatted: '€0.00'
})

export { DEFAULT_NEW_MONEY }
export type { MoneyModel }
